<div
  *ngIf="expenseCategories && parentFormGroup"
  [formGroup]="parentFormGroup">
    <ph-stack>
      <div formArrayName="expenseCategories">
        <ph-stack gap="tight">
            <ph-card *ngFor="let split of expenseCategories.controls; let i=index; trackBy: trackBySplit"
                     flat
                     [formGroupName]="i"
                     [heading]="isSplit ? 'Category ' + (i + 1) : null">
                <ph-button *ngIf="isSplit"
                           slot="actions"
                           variant="error" mode="ghost" icon-only icon="trash" size="xsmall"
                           aria-label="Remove this category"
                           (click)="removeSplit(i)"></ph-button>
                <ph-toolbar>
                    <ph-field>
                        <ph-label required>Expense category</ph-label>
                        <app-category-picker
                            [formGroup]="split"
                            [organizationId]="organizationId"
                            controlName="expenseCategory"
                            [showEquities]="hasAccrualAccounting"
                            [showAssets]="hasAccrualAccounting"
                            [showLiabilities]="hasAccrualAccounting"
                            (loadstart)="onExpenseCategoriesLoadingStart()"
                            (loadeddata)="onExpenseCategoriesLoadingEnd()"
                        >
                        </app-category-picker>
                    </ph-field>
                    <ph-field>
                        <ph-label required>Amount</ph-label>
                        <ph-money-input formControlName="expenseCategoryAmount"
                                        ngDefaultControl
                                        validateDecimal
                                        [readonly]="isSingleCategoryReadonly"
                                        [hasError]="split.get('expenseCategoryAmount')?.touched &&
                                                    (split.get('expenseCategoryAmount')?.invalid ||
                                                    invalidControls.includes('splitAmountMismatch'))">
                        </ph-money-input>
                    </ph-field>
                </ph-toolbar>
            </ph-card>
        </ph-stack>
      </div>

      <ph-actions>
        <ph-link-button variant="primary" size="small" icon="plus" (click)="addSplit()">Add category</ph-link-button>
      </ph-actions>

      <ph-alert *ngIf="validationError" status="error">{{ validationError }}</ph-alert>
    </ph-stack>
</div>
